var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasemenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "menu_icon",
    "data-name": "menu icon",
    width: 34,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAATCAYAAAD1Yd/KAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVRIic3Vv48NURQH8M+bXYIlJGyIH6GyT6vYUqNUs4WN0Gzlz5GISkgUZGuVSkmo7VYk1m9i89gIb98o5oy95s3MG9X6Nvee877fc7735s55vTzPD+Aq5pD5G9/xEI+S3Gks4rBxvMc9rCS587iAmQp3hFXcxtcMV3CmxoQQX0Q/4l1YajAh8kvBK01fqjEh+vWj/59gEuZiPYZ9E7h7cTL2XWr3SyNTHcjlbfU6cGFnrF1qT6UNth0Z8g68LpwUw3/Q5aWR1x3Ia7F+xOYE7ghvYt+5dqb43AYtxKd4Fvt1PLB14iqG8ft6xM9D34RB9NfL8xx24IjxN7OhuIUqdmPW+OP9ov5Qs9hTyeV4i1+pkW3HdKxNN/INn2t0MzhUk/+kmMZVHFTMlxQjvBM3Mo1TuK55UD1RjOFRxOewkBwixRD38TjiDNcw31B7gBt4meFyiwlR5Gzs97eYEPmF4AldkwnRd7F0fKKFWOJ4rLMtJlIzRyu6ibUz3cZ219Gemumq65VG/gtkJk9Kth5q12/9Z0XXhs3SyMoEooSzphhybfiBVxVdG1ZLI3cjqDvtBpbxImlyS/FfUsf/gJvBE7rlBvN59L0DvwGTMWY3hkqyKQAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasemenu);
export default __webpack_public_path__ + "static/media/casemenu.0c3bac1a60ccfdd756be48b94087b971.svg";
export { ForwardRef as ReactComponent };